const Status = {
  ERROR: "ERROR",
  MESSAGE: "MESSAGE",
  NOTICE: "NOTICE",
  SUCCESS: "SUCCESS",
  ANNOUNCEMENT: "ANNOUNCEMENT",
};

export default Status;
